import React from 'react';
import { clsx } from 'clsx';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-9 h-9',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
};

const Logo: React.FC<LogoProps> = ({ size = 'sm', className }) => (
  <img
    src="/logo.png"
    alt="Redd Family logo"
    className={clsx(sizeClasses[size], 'rounded-lg object-cover', className)}
  />
);

export { Logo };
